"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUid = exports.addDocuments = exports.addSection = void 0;
var fc = require("../firebase/fire_constants");
var lu = require("./local_util");
function addSection(id, path, info, anchor) {
    info = "Select " + info + " to work on:";
    var hr = document.createElement('hr');
    hr.setAttribute('style', 'width:100%;border-width:0;background-color:#B1DF84;color:#B1DF84;height:6px');
    var outerDiv = document.createElement('div');
    outerDiv.classList.add('converter');
    outerDiv.id = id + 'table';
    var innerDiv = document.createElement('div');
    innerDiv.classList.add('section');
    innerDiv.textContent = info;
    var table = createTable(id, path);
    outerDiv.append(innerDiv, table);
    anchor.append(hr, outerDiv);
}
exports.addSection = addSection;
function createTable(id, path) {
    var table = document.createElement('table');
    table.id = id;
    var tr = document.createElement('tr');
    tr.classList.add('heading');
    tr.innerHTML = '<th>Name</th><th>Information</th><th>Path</th>';
    table.appendChild(tr);
    addDocuments(table, path);
    return table;
}
function addDocuments(node, path) {
    var storage = lu.getStorage(fc.NemethProjectDocuments);
    if (storage) {
        var documents = JSON.parse(storage);
        createRows(documents.filter(function (doc) { return doc.path.match(path); }), node);
    }
}
exports.addDocuments = addDocuments;
function getUid() {
    return lu.getFirebase().auth().getUid();
}
exports.getUid = getUid;
function createRows(documents, anchor) {
    var e_1, _a;
    documents.sort(function (x, y) {
        return ('' + x.name).localeCompare(y.name);
    });
    var _loop_1 = function (entry) {
        var row = document.createElement('tr');
        row.setAttribute('tabindex', '0');
        row.classList.add('selection');
        row.innerHTML = "<td class=\"selection\">" + entry.name + "</td>"
            + ("<td>" + entry.information + "</td><td>" + entry.path + "</td>");
        row.addEventListener('click', function () {
            lu.setStorage(fc.NemethProjectPath, entry.path);
            lu.setStorage(fc.NemethProjectUser, getUid());
            window.location.assign('brf2nemeth.html');
        });
        row.addEventListener('keyup', function (e) {
            if (e.key === 'Enter') {
                lu.setStorage(fc.NemethProjectPath, entry.path);
                lu.setStorage(fc.NemethProjectUser, getUid());
                window.location.assign('brf2nemeth.html');
            }
        });
        anchor.appendChild(row);
    };
    try {
        for (var documents_1 = __values(documents), documents_1_1 = documents_1.next(); !documents_1_1.done; documents_1_1 = documents_1.next()) {
            var entry = documents_1_1.value;
            _loop_1(entry);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (documents_1_1 && !documents_1_1.done && (_a = documents_1.return)) _a.call(documents_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
